<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent()"
  [title]="titlePage"
  start="{{ startStage }}"
  end="{{ endStage }}"
></app-ion-common-header>

<app-loading-circle *ngIf="loading"> </app-loading-circle>

<ion-content
  *ngIf="!showRetry && !loading"
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <app-ion-common-label
    labelStyle="display-rg"
    [id]="idLabelDocumentType"
    labelDescription="Qual documento você prefere usar?"
    label="Para facilitar a abertura da sua conta, tenha em mãos o documento selecionado."
  >
  </app-ion-common-label>

  <div class="conent-center">
    <app-ion-common-radio
      [id]="idRadioDocumentType"
      [ariaLabel]="textAria"
      [disabled]="!this.edit"
      [itens]="documentType"
      [selectedValue]="selectedItem"
      (changeRadio)="changeItem((selectedItem = $event))"
      (valueNameRadio)="selectedName = $event"
    ></app-ion-common-radio>
  </div>

  <app-ion-common-button
    [id]="idRadioButtonDocumentType"
    class="hidden"
    [ngClass]="{ hidden: !buttonEnable || !selectedItem }"
    [attr.aria-hidden]="!buttonEnable || !selectedItem"
    label="Continuar"
    (clickButton)="clickNext()"
  ></app-ion-common-button>
</ion-content>

<ion-content *ngIf="showRetry" [attr.aria-hidden]="ariaHidden">
  <app-ion-common-retry
    [id]="idRetryDocumentType"
    [headerId]="headerId"
    (sendEventRetry)="getDomainType()"
  >
  </app-ion-common-retry>
</ion-content>
